export const environment = {
  production: true,
  apiURL: 'https://beta.api.wattzhub.com/',
  STRIPE_KEY: 'pk_test_syoT5vZ0oHThoQiS7gfvF5xs00hkNVcx1w'
};

